import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { purpurShadowMd } from "@purpurds/tokens/shadow/variables";
import { purpurColorFunctionalBlack, purpurColorFunctionalWhite } from "@purpurds/tokens/color/variables";
import styled from "styled-components";
const HeaderWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  box-shadow: ${purpurShadowMd};
  min-height: 50px;
  background-color: ${purpurColorFunctionalWhite};
  z-index: ${props => props.$onMap ? 4 : 6};
  border-radius: 4px;
  position: ${props => props.$onMap ? 'absolute' : 'relative'};
  ${props => props.$onMap && {
    top: 0,
    left: 0,
}}
`;
const HeaderText = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 22px;
  margin: 0 50px;
  width: 100%;
  padding: 0.3em 0;
`;
const MainText = styled.span `
  font-size: ${props => props.$hasSubHeading ? '20px' : '22px'};
  font-weight: ${props => props.$hasSubHeading ? 500 : 400};
`;
const SubText = styled.span `
  font-size: 18px;
  max-width: calc(100% - (48 * 2));
  text-align: center;
`;
const LeftIconWrapper = styled.span `
  position: absolute;
  left: 11px;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorFunctionalBlack};
  cursor: pointer;
`;
const RightIconWrapper = styled.div `
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
`;
export const ComponentHeader = ({ leftIcon = null, mainHeading, rightIcon = null, showLeftIcon = false, subHeading = '', isOnMap = false, }) => {
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1);
    };
    return (_jsxs(HeaderWrapper, { "$onMap": isOnMap, children: [_jsx(LeftIconWrapper, { children: showLeftIcon ? (_jsx(StyledIcon, { svg: icons.arrowLeft, size: "lg", onClick: handleGoBack })) : (leftIcon) }), _jsxs(HeaderText, { children: [_jsx(MainText, { "$hasSubHeading": !!subHeading, children: mainHeading }), subHeading && _jsx(SubText, { children: subHeading })] }), !!rightIcon && (_jsx(RightIconWrapper, { children: rightIcon }))] }));
};
